import React from 'react';

const SendBtnSvg = () => (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22 10L0 0L2.08939 8.55346L9.77095 10L2.08939 11.4465L0 20L22 10Z" fill="#439ADE"/>
    </svg>
)

export default SendBtnSvg;